import { Observable } from 'rxjs';
import { Component, OnInit, OnDestroy, Injector, Input } from '@angular/core';
import { BaseComponent } from '@shared/components/base.component';
import { TooltipDialogComponent } from '@shared/components/tooltip-dialog/tooltip-dialog.component';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styles: [
  ]
})
export class TooltipComponent extends BaseComponent implements OnInit, OnDestroy {

  @Input() titleKey: string;
  @Input() title: string;
  @Input() message: String;
  @Input() msgKey: string;
  @Input() msgParams: string[];

  constructor(private injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  openTooltipDialog() {
    this.dialogService.instance(TooltipDialogComponent, {
      titleKey: this.titleKey,
      title: this.title,
      message: this.message,
      msgKey: this.msgKey,
      msgParams: this.msgParams
    });
  }

}
